module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./RuleView.js"));
	}, "PlusRuleView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PlusRuleView!./src/pages/Learn/PlusRule/RuleView.js
// module id = 2233
// module chunks = 367